/**
 * FastingConsentModal - Extracted from App.js Phase 4
 * Intermittent fasting acknowledgment and schedule selection
 */
import React from 'react';

const FastingConsentModal = ({
  isOpen,
  onClose,
  mealPlanPreferences,
  setMealPlanPreferences,
  setFastingConsentGiven
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" style={{ zIndex: 1002 }}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '520px' }}>
        <h2 className="heading-3">Intermittent Fasting Acknowledgment</h2>
        
        <div style={{ marginTop: '20px', marginBottom: '24px', lineHeight: '1.7', fontSize: '14px', color: 'var(--text-primary)' }}>
          <div style={{ background: 'rgba(255, 152, 0, 0.1)', border: '1px solid rgba(255, 152, 0, 0.3)', borderRadius: '8px', padding: '14px', marginBottom: '16px' }}>
            <p style={{ margin: 0, fontSize: '13px', color: '#ff9800' }}>
              <strong>Important:</strong> Intermittent fasting is an eating pattern, not medical advice. 
              This feature affects <strong>meal timing suggestions only</strong> and does not change your calorie or nutrition targets.
            </p>
          </div>
          
          <p style={{ marginBottom: '16px' }}><strong>Before enabling, please note:</strong></p>
          <ul style={{ marginLeft: '20px', marginBottom: '16px' }}>
            <li style={{ marginBottom: '8px' }}>Consult a healthcare provider before starting any fasting regimen, especially if you have medical conditions</li>
            <li style={{ marginBottom: '8px' }}>Fasting may not be suitable for everyone, including pregnant/nursing women, people with diabetes, eating disorders, or other conditions</li>
            <li style={{ marginBottom: '8px' }}>This feature only adjusts meal timing in generated meal plans</li>
            <li style={{ marginBottom: '8px' }}>You can disable this feature at any time</li>
          </ul>
          
          <p style={{ marginBottom: '16px', fontSize: '13px', color: 'var(--text-secondary)' }}>
            SmartplAIte does not make medical claims about intermittent fasting. 
            Any lifestyle changes should be discussed with qualified healthcare professionals.
          </p>
        </div>
        
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', fontSize: '14px' }}>
            Select Your Fasting Schedule:
          </label>
          <select
            value={mealPlanPreferences.fastingSchedule}
            onChange={(e) => setMealPlanPreferences({...mealPlanPreferences, fastingSchedule: e.target.value})}
            className="search-input"
            style={{ width: '100%' }}
          >
            <option value="">-- Choose a schedule --</option>
            <option value="16:8">16:8 - 16hr fast, 8hr eating window (Most Popular)</option>
            <option value="18:6">18:6 - 18hr fast, 6hr eating window</option>
            <option value="20:4">20:4 - 20hr fast, 4hr eating window</option>
            <option value="5:2">5:2 - 5 normal days, 2 low-cal days</option>
            <option value="eat-stop-eat">Eat-Stop-Eat - 24hr fast 1-2x/week</option>
          </select>
        </div>
        
        <button 
          className="btn-primary full-width"
          onClick={() => {
            if (!mealPlanPreferences.fastingSchedule) {
              alert('Please select a fasting schedule before continuing.');
              return;
            }
            setFastingConsentGiven(true);
            onClose();
            setMealPlanPreferences({...mealPlanPreferences, intermittentFasting: true});
          }}
        >
          I Understand - Enable Fasting Schedule
        </button>
        
        <button className="btn-secondary full-width" onClick={onClose} style={{ marginTop: '12px' }}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default FastingConsentModal;
